import * as Yup from "yup";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import { useRecoilValue } from "recoil";
import { IconHelp } from "@tabler/icons";
import useStyles from "../../../styles/styles";
import { configState } from "../../../recoil/atoms";
import { InputField } from "../../../utils/FormFields";
import { CurrencyApi } from '../../../api/payment/apis/currency-api';
import { Button, Divider, Grid, IconButton, Tooltip, Typography } from "@mui/material";

type props = {
  handleCloseModal: Function;
  editCurrency?: any;
  isEdit?: Boolean;
};

const CurrencyModal = ({ handleCloseModal, editCurrency, isEdit }: props) => {
  const classes = useStyles();
  const config = useRecoilValue(configState);

  const addCurrency = (values: any) => {
    const Currency = new CurrencyApi(config);
    Currency.createCurrency(values)
      .then((res) => {
        toast.success("Successfully added!");
        handleCloseModal();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const editPaymentCurrency = (values: any) => {    
    const Currency = new CurrencyApi(config);
    Currency
      .editCurrency(editCurrency?.currency_id!, values)
      .then((res) => {
        toast.success(res?.data?.message!);
        handleCloseModal();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const handleSubmit = (values: any, actions: any) => {
    const editedValues: any = {
      name: values?.name,
      shortcut: values?.shortcut,
      rate_from_usd: values?.rate_from_usd,
    };
    isEdit ? editPaymentCurrency(editedValues) : addCurrency(values);
  };

  const hint = () => (
    <Tooltip title="Currency Rate from USD">
      <IconButton>
        <IconHelp />
      </IconButton>
    </Tooltip>
  );

  return (
    <>
      <Formik
        initialValues={editCurrency ? editCurrency : { name: undefined, shortcut: undefined, rate_from_usd: undefined }}
        enableReinitialize={true}
        validationSchema={Yup.object().shape({
          name: Yup.string()
            .trim()
            .matches(/^[a-zA-Z0-9\s']+$/, "Incorrect format")
            .min(0, "Cannot be empty")
            .max(20, "Must be 20 characters or less")
            .required("Required"),
          shortcut: Yup.string()
            .trim()
            .matches(/^[a-zA-Z0-9\s']+$/, "Incorrect format")
            .min(0, "Cannot be empty")
            .max(3, "Must be 3 characters or less")
            .required("Required"),
          rate_from_usd: Yup.number().required("Required").min(0, "Rate cannot be negative"),
        })}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <Typography variant="h5" gutterBottom sx={{ p: 0 }}>
              {isEdit ? "Edit Currency" : "Add Currency"}
            </Typography>
            <Divider />
            <Grid
              container
              rowSpacing={4}
              spacing={2}
              sx={{
                pt: 4,
                mt: 2,
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              <Grid item xs={12} sm={10}>
                <InputField name="name" label="Name" fullWidth />
              </Grid>
              <Grid item xs={12} sm={10}>
                <InputField name="shortcut" label="Shortcut" fullWidth />
              </Grid>
              <Grid container />
              <Grid container />
              <Grid item xs={12} sm={10}>
                <InputField name="rate_from_usd" label="Rate from USD" fullWidth type="number" suffix={hint()} />
              </Grid>
            </Grid>
            <Grid container className={classes.buttons} sx={{ mt: 6 }}>
              <Grid item className={classes.wrapper}>
                <Button onClick={() => handleCloseModal()} variant="contained" color="error" className={classes.button}>
                  Cancel
                </Button>
                <Button type="submit" variant="contained" color="secondary" className={classes.button}>
                  {isEdit ? "Edit Currency" : "Add Currency"}
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default CurrencyModal;
